// Used to show share prompt on clips page
const ss = window.slideshare_object
let CB = ss.Clipboards,
  isMobile = ss.is_mobile,
  ClipboardModalShare = ss.utils.imports("ClipboardModalShare"),
  NoticePrompt = ss.utils.imports("NoticePrompt"),
  /* Selectors */
  selectors = {
    parent: ".clipboards",
    shareModal: "#clipboard-share-modal",
    shareWrapper: ".share-prompt-wrapper",
    shareCTA: ".share-prompt-cta",
  },
  /* Local storage keys */
  storageKeys = {
    promptClose: "slideshare.clips.sharePrompt.closed",
  }

/**
 * Initiates a new share prompt from generic notice prompt class
 * @constructor
 */
function SharePrompt() {
  this._init()
}

SharePrompt.prototype = {
  constructor: SharePrompt,

  /**
   * Initialize share prompt
   * @private
   */
  _init: function () {
    this.$el = $(selectors.shareWrapper)

    this.clipboard = $(selectors.parent).data()
    this.noticePrompt = new NoticePrompt({
      selector: selectors.shareWrapper,
      onClose: this._closed.bind(this),
    })
    this.closedByUser = this._isClosedByUser() || 0
    this._attachEventHandlers()
  },

  /**
   * Attach various event handlers here
   * @private
   */
  _attachEventHandlers: function () {
    this.$el.on("click", selectors.shareCTA, this._showShareModal.bind(this))
  },

  /**
   * event handler for prompt close by user
   * @method _closed
   * @private
   */
  _closed: function () {
    this.closedByUser = 1
    window.localStorage.setItem(this._localStorageKey(), this.closedByUser)
  },

  /**
   * Determines if user has closed the prompt on this clipboard in past
   * @private
   */
  _isClosedByUser: function () {
    this.closedByUser = +window.localStorage.getItem(this._localStorageKey())
    return this.closedByUser
  },

  /**
   * Creates local storage key for current user and clipboard
   * format: storagekeys.promptclose.clipboard:{clipboard_id}.user:{user_id}
   * @private
   */
  _localStorageKey: function () {
    let keyPartsHolder = []
    keyPartsHolder.push(storageKeys.promptClose)

    this.clipboard && this.clipboard.id && keyPartsHolder.push("clipboard:" + this.clipboard.id)

    ss.user && ss.user.id && keyPartsHolder.push("user:" + ss.user.id)
    return keyPartsHolder.join(".")
  },

  /**
   * Calls notice prompt show
   */
  show: function () {
    if (this._isClosedByUser() || isMobile || this.clipboard.private) {
      return
    }
    this.noticePrompt.show()
  },

  /**
   * Calls notice prompt hide
   */
  hide: function () {
    this.noticePrompt.hide()
  },

  /**
   * shows share modal box on clips page
   * @private
   */
  _showShareModal: function () {
    let shareModal = new ClipboardModalShare({
      el: selectors.shareModal,
      shareEntity: this.clipboard,
    })

    shareModal.open()
    this.hide()
  },
}

export default SharePrompt
